module.exports = __webpack_public_path__ + "static/media/cheesesteak-dumpling.b6bc3623.png";